import React, { useEffect } from 'react';
import Layout from '../../../components/layout/Layout';
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";
import CommonInvite from "../../../common/component/CommonInvite/CommonInvite";
import LayoutV2 from '../../../components/layout-v2';


import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";


function StayTuned() {
    const moveOnUrl = () => {
        const url = location.host;
        const newUrl = url.includes('superworks.com') ? 'https://superworks.com/' : 'https://beta.superworks.com/';
        window.open(newUrl, '_self');
    }
    return (
        <React.Fragment>
            <LayoutV2 module="stay-tuned">
                <div className="u_p-24">
                    <img src="../images/images/stay-tuned.png" className="u_m-auto" />
                    <CommonInvite heading="Stay Tuned!"
                        title="One of our sales representatives will get in touch with you for easier support regarding Superworks features, functionalities and free trial.
Also, you can schedule an online demo at your feasible time and hold on while we bring in the best experience for you!"/>
                    <div className="u_flex u_content-between">
                        <button
                            type="button"
                            onClick={moveOnUrl}
                            className="u_btn u_btn__white u_w-full u_cp"
                            data-testid={TEST_ID.STAY_TUNED.HOME_BUTTON}>Go to Home
                        </button>
                        <button
                            type="button"
                            onClick={() => window.open('https://meetings.hubspot.com/bookappointment/book-demo-with-ubs')}
                            className="u_btn u_btn__blue u_w-full u_cp"
                            data-testid={TEST_ID.STAY_TUNED.SCHEDULE_DEMO_BUTTON}>Schedule Demo
                        </button>
                    </div>
                </div>
            </LayoutV2>
        </React.Fragment>
    );
}

export default StayTuned;
